import React, { useState, useEffect } from "react";
import axios from "axios";
import Grid from '@mui/material/Grid';
import { useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import "./style.css";

import {
  Typography, Paper, Table, TableBody,
  TableCell, TableContainer, TableHead,
  TableRow, Dialog, DialogTitle,
  DialogContent, DialogActions, Button,
  TextField, Box,
  FormControl, InputLabel, Select, MenuItem,
  RadioGroup, Radio, FormControlLabel
} from "@mui/material";

import Autocomplete from '@mui/material/Autocomplete';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDateTimePicker } from '@mui/x-date-pickers/DesktopDateTimePicker';

import LeftMenu from "../../components/left-menu/index.js";

// GRADE CARDS
const gradeOptions = [
  { id: 'card1', emoji: '🤔', text: 'Belum tau / Masih belum dibalas', score: 0 },
  { id: 'card2', emoji: '😊', text: 'Mungkin ada Potensi', score: 5 },
  { id: 'card5', emoji: '📍', text: 'Lokasi Tidak Sesuai', score: -2 },
  { id: 'card6', emoji: '📦', text: 'Produk Tidak Sesuai', score: -2 },
  { id: 'card7', emoji: '💸', text: 'Harga Tidak Sesuai', score: 3 },
  { id: 'card8', emoji: '🤬', text: 'Spam / Penipuan', score: -5 },
  { id: 'card9', emoji: '👻', text: 'Sudah 2-3X FU tidak pernah Respon Lagi', score: -1 },
];

// API Calls
async function readEmpty() {
  try {
    const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/stage2todo`);
    return response.data; // { success: true, data: [...] }
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
}

async function updateStage2(payload) {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}/updateStage2`,
      payload
    );
    return response.data; // { success: true, data: updatedDoc }
  } catch (error) {
    console.error("Error updating stage1:", error);
    throw error;
  }
}

export default function LegalProcess() {
  const nowstate = useSelector(state => state);
  const navigate = useNavigate();

  // Hard-coded options
  const [names] = useState([
    "Instagram/Facebook Ads",
    "Google Ads (LiveChat)",
    "Google Ads (WhatsApp)",
    "Partner",
    "Kenalan",
    "Ga Tau",
    "OLX"
  ]);
  const [produk] = useState([
    "Virtual Office",
    "Private Office",
    "Meeting Room Kecil",
    "Meeting Room Besar (Event Room)",
    "Pendirian PT",
    "Pendirian CV",
    "Izin Khusus",
    "PKP",
    "Pajak",
    "Akutansi",
    "Website",
    "Merek"
  ]);
  const [lokasi] = useState([
    "Jakarta Selatan",
    "Jakarta Barat",
    "Jakarta Pusat",
    "Jakarta Utara",
    "Jakarta Timur",
    "Tangerang",
    "Bekasi",
    "Bali",
    "Surabaya",
    "Depok",
    "Kalimantan"
  ]);
  const [salesList] = useState(["Sales1", "Dinda", "Diva"]);
  const [adCodes] = useState(["AD123", "COUPON-XYZ", "SPECIAL99"]);
function getName(post) {
  return post.type === 'legacy'
    ? (post.Nama ? post.Nama.slice(0, 7) : 'N/A')
    : (post.inquiryData?.Nama || 'N/A')

}
function getDate(post) {
  if (post.type === 'legacy') {
    return post.InqDate ? new Date(post.InqDate).toLocaleString() : '(no date)';

  } else {
    if (post.notes && post.notes.length > 0 && post.notes[0].Date) {
      return formatDisplayDate(post.notes[0].Date);
    }
    return "N/A";
  }
}


function getPhone(post) {
  return post.type === 'legacy'
    ? (post.Phone || 'N/A')
    : (post.inquiryData?.Phone || 'N/A');
}

function getMainNote(post) {
  return post.type === 'legacy'
    ? (post.Notes || 'N/A')
    : ((post.notes && post.notes.length > 0) ? post.notes[0].Note : 'N/A');
}

function getAdcode(post) {
  return post.type === 'legacy'
    ? (post.Notes || 'N/A')
    : ((post.notes && post.notes.length > 0) ? post.notes[0].Note : 'N/A');
}

function getOtherNote(post) {
  return post.type === 'legacy'
    ? (post.management.fu || 'N/A')
    : (post.notes || 'N/A');
}

function getSales(post) {
  return post.type === 'legacy'
    ? (post.Sales ? post.Sales.slice(0, 7) : 'N/A')
    : (post.inquiryData.Sales ? post.inquiryData.Sales.slice(0, 7) : 'N/A')
}
  // Table data
  const [inquiries, setInquiries] = useState([]);

  // Dialog
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);

  // All fields we might edit or display
  const [formData, setFormData] = useState({});

  // Whether or not we are editing the "Previous Data" section
  const [editMode, setEditMode] = useState(false);

  // Backup for "previous data" if user cancels edit
  const [backupData, setBackupData] = useState({});

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    try {
      const response = await readEmpty();
      console.log("Backend response:", response);
      // Normalize legacyInquiries (if any)
      const legacyPosts = Array.isArray(response.legacyInquiries)
        ? response.legacyInquiries.map((post) => ({ ...post}))
        : [];
      // Normalize tickets (if any)
      const ticketPosts = Array.isArray(response.tickets)
        ? response.tickets.map((ticket) => ({ ...ticket}))
        : [];
      // Combine both arrays. (You could also sort them by date if desired.)
      setInquiries([...legacyPosts, ...ticketPosts]);
    } catch (err) {
      console.error('Error fetching posts:', err);
    }
  }

  // Format date in table
  const formatDisplayDate = (dateString) => {
    if (!dateString) return "N/A";
    const d = new Date(dateString);
    if (isNaN(d.getTime())) return "N/A";
    return d.toLocaleString();
  };

  const getRowStyle = (row) => {
    if (row.ticket) {
      console.log("nonlegacy");
      if (
        row.ticket.Stage3 === "true" ||
        (row.ticket.Stage2 === "false" && row.ticket.Stage3 === "false")
      ) {
        return { backgroundColor: "lightgreen" };
      }
    } else {
      console.log("legacy");
      if (
        row.Stage3 === "true" ||
        (row.Stage2 === "false" && row.Stage3 === "false")
      ) {
        return { backgroundColor: "lightgreen" };
      }
    }
    return {};
  };
  

  // Clicking a row => open the dialog
  const handleRowClick = (row) => {
    console.log(row)
    console.log(row.ticket)
    setSelectedRowId(row._id);

    // Convert row.InqDate to Date if valid
    let inqDateVal = null;
    if (row.InqDate) {
      const dt = new Date(row.InqDate);
      if (!isNaN(dt.getTime())) {
        inqDateVal = dt;
      }
    }

    // Default followUpDate to now
    const now = new Date();

    // Fill in form data
    const newForm = {
      InqDate: getDate(row),
      Nama: getName(row),
      Iklan: row.Iklan ?? "",
      Phone: getPhone(row) ?? "",
      ProdukInterest: Array.isArray(row.ProdukInterest) ? row.ProdukInterest : [],
      LokasiInterest: Array.isArray(row.LokasiInterest) ? row.LokasiInterest : [],
      Notes: getMainNote(row),
      AdCode: row.AdCode ?? "",

      // existing scoring
      grade: row.inqGrade ?? "",

      // next step defaults
      isDropped: row.isDropped ?? false,
      isPromo: false,
      Sales: getSales(row) ?? "",
      followUpDate: now,
      managementNotes: "",
      // Store entire fu array for section 2 display
      managementFu: getOtherNote(row),
      type:row.type?? "",
      entire:row,
    };

    setFormData(newForm);

    // Backup for editing (previous data)
    setBackupData({
      InqDate: inqDateVal,
      Nama: newForm.Nama,
      Iklan: newForm.Iklan,
      Phone: newForm.Phone,
      ProdukInterest: [...newForm.ProdukInterest],
      LokasiInterest: [...newForm.LokasiInterest],
      Notes: newForm.Notes,
      AdCode: newForm.AdCode,
      grade: newForm.grade,
    });

    setEditMode(false);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRowId(null);
    setFormData({});
    setBackupData({});
    setEditMode(false);
  };

  const handleEdit = () => setEditMode(true);

  const handleDoneEdit = () => {
    setEditMode(false);
  };

  const handleCancelEdit = () => {
    // revert from backup
    setFormData((prev) => ({
      ...prev,
      InqDate: backupData.InqDate,
      Nama: backupData.Nama,
      Iklan: backupData.Iklan,
      Phone: backupData.Phone,
      ProdukInterest: [...backupData.ProdukInterest],
      LokasiInterest: [...backupData.LokasiInterest],
      Notes: backupData.Notes,
      AdCode: backupData.AdCode,
      grade: backupData.grade,
    }));
    setEditMode(false);
  };

  // Generic field updater
  const handleFieldChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  // When user clicks a grade card
  const handleGradeClick = (gradeId) => {
    setFormData(prev => ({ ...prev, grade: gradeId }));
  };

  // Save to server
  const handleSave = async () => {
    if (!selectedRowId) return;

    // Convert InqDate to ISO if valid
    let isoInqDate = null;
    if (formData.InqDate instanceof Date && !isNaN(formData.InqDate)) {
      isoInqDate = formData.InqDate.toISOString();
    }

    // Convert followUpDate to ISO if relevant
    let isoFollowUp = null;
    // Only if not dropped or promo do we consider that date a next follow-up
    // But if you want to store the date for promo as well, you can remove "&& !formData.isPromo"
    if ((!formData.isDropped || formData.isPromo) && formData.followUpDate instanceof Date && !isNaN(formData.followUpDate)) {
      isoFollowUp = formData.followUpDate.toISOString();
    }

    // Get inqScore from the grade
    let chosenScore = 0;
    const foundGrade = gradeOptions.find((g) => g.id === formData.grade);
    if (foundGrade) chosenScore = foundGrade.score;

    // If dropped or promo => no sales
    const finalSales = (!formData.isDropped && !formData.isPromo)
      ? formData.Sales
      : "";

    // Build payload
    const payload = {
      id: selectedRowId,
      InqDate: isoInqDate,
      Nama: formData.Nama,
      Iklan: formData.Iklan,
      Phone: formData.Phone,
      ProdukInterest: formData.ProdukInterest,
      LokasiInterest: formData.LokasiInterest,
      Notes: formData.Notes,
      AdCode: formData.AdCode,

      // next step
      inqGrade: formData.grade,
      inqScore: chosenScore,
      isDropped: formData.isDropped,
      isPromo: formData.isPromo,
      Sales: finalSales,
      followUpDate: isoFollowUp,
      managementNotes: formData.managementNotes,
      type:formData.type,
      entire:formData.entire
    };

    try {
      // Normalize updatedDoc so that if it's non-legacy, the ticket stages are set as desired.
const normalizeUpdatedDoc = (doc) => {
  const normalized = { ...doc };
  // If there's ticket data and the update is non‑legacy (or type is not "legacy")
  if (normalized.ticket && (!normalized.type || normalized.type !== "legacy")) {
    normalized.ticket.Stage1 = "true";
    normalized.ticket.Stage2 = "false";
    normalized.ticket.Stage3 = "false";
  }
  return normalized;
};

try {
  const res = await updateStage2(payload);
  if (res.success) {
    console.log("this is the data");
    console.log(res.data);
    // Remove the row with the same ID as the one that was updated
    setInquiries((prev) => prev.filter((item) => item._id !== selectedRowId));
    handleCloseDialog();
  } else {
    console.error("Server responded with error:", res.error);
  }
} catch (err) {
  console.error("Error saving stage1:", err);
}



    } catch (err) {
      console.error("Error saving stage1:", err);
    }
  };

  // Renders read-only view of previous data
  const renderPreviousDataReadOnly = () => (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <Typography variant="subtitle2" sx={{ mt: 2 }}>Inquiry Date</Typography>
        <Typography variant="body1" sx={{ mb: 1 }}>
        { 
  formData.InqDate 
    ? formData.InqDate.toLocaleString() 
    : (formData.inquiryData?.InqDate 
         ? formData.inquiryData.InqDate 
         : "N/A")
}
        </Typography>

        <Typography variant="subtitle2">Name</Typography>
        <Typography variant="body1" sx={{ mb: 1 }}>
          {formData.Nama || "N/A"}
        </Typography>

        <Typography variant="subtitle2">Phone</Typography>
        <Typography variant="body1" sx={{ mb: 1 }}>
          {formData.Phone || "N/A"}
        </Typography>

        <Typography variant="subtitle2">Notes</Typography>
        <Typography variant="body1" sx={{ mb: 1 }}>
          {formData.Notes || "N/A"}
        </Typography>
      </Grid>

      <Grid item xs={12} md={6}>
        <Typography variant="subtitle2">From (Iklan)</Typography>
        <Typography variant="body1" sx={{ mb: 1 }}>
          {formData.Iklan || "N/A"}
        </Typography>

        <Typography variant="subtitle2">Produk Interest</Typography>
        <Typography variant="body1" sx={{ mb: 1 }}>
          {Array.isArray(formData.ProdukInterest) && formData.ProdukInterest.length > 0
            ? formData.ProdukInterest.join(', ')
            : "N/A"}
        </Typography>

        <Typography variant="subtitle2">Lokasi Interest</Typography>
        <Typography variant="body1" sx={{ mb: 1 }}>
          {Array.isArray(formData.LokasiInterest) && formData.LokasiInterest.length > 0
            ? formData.LokasiInterest.join(', ')
            : "N/A"}
        </Typography>

        <Typography variant="subtitle2">Ad Code</Typography>
        <Typography variant="body1" sx={{ mb: 1 }}>
          {formData.AdCode || "N/A"}
        </Typography>

        <Typography variant="subtitle2">Existing Grade</Typography>
        <Typography variant="body1">
          {formData.grade
            ? gradeOptions.find((g) => g.id === formData.grade)?.text || formData.grade
            : "N/A"}
        </Typography>
      </Grid>
    </Grid>
  );

  // Renders editable view of previous data
  const renderPreviousDataEdit = () => (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <Typography variant="subtitle2" sx={{ mt: 2 }}>Inquiry Date</Typography>
        <DesktopDateTimePicker
          value={formData.InqDate || null}
          onChange={(newVal) => handleFieldChange("InqDate", newVal)}
          renderInput={(params) => <TextField fullWidth sx={{ mb: 2 }} {...params} />}
        />

        <Typography variant="subtitle2">Name</Typography>
        <TextField
          fullWidth
          sx={{ mb: 2 }}
          value={formData.Nama || ""}
          onChange={(e) => handleFieldChange("Nama", e.target.value)}
        />

        <Typography variant="subtitle2">Phone</Typography>
        <TextField
          fullWidth
          sx={{ mb: 2 }}
          value={formData.Phone || ""}
          onChange={(e) => handleFieldChange("Phone", e.target.value)}
        />

        <Typography variant="subtitle2">Notes</Typography>
        <TextField
          fullWidth
          multiline
          rows={3}
          sx={{ mb: 2 }}
          value={formData.Notes || ""}
          onChange={(e) => handleFieldChange("Notes", e.target.value)}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <Typography variant="subtitle2">From (Iklan)</Typography>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel>Ad Source</InputLabel>
          <Select
            value={formData.Iklan || ""}
            label="Ad Source"
            onChange={(e) => handleFieldChange("Iklan", e.target.value)}
          >
            {names.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Typography variant="subtitle2">Produk Interest</Typography>
        <Autocomplete
          multiple
          options={produk}
          value={Array.isArray(formData.ProdukInterest) ? formData.ProdukInterest : []}
          onChange={(event, newVal) => handleFieldChange("ProdukInterest", newVal)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Produk"
              sx={{ mb: 2, mt: 1 }}
            />
          )}
        />

        <Typography variant="subtitle2">Lokasi Interest</Typography>
        <Autocomplete
          multiple
          options={lokasi}
          value={Array.isArray(formData.LokasiInterest) ? formData.LokasiInterest : []}
          onChange={(event, newVal) => handleFieldChange("LokasiInterest", newVal)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Lokasi"
              sx={{ mb: 2, mt: 1 }}
            />
          )}
        />

        <Typography variant="subtitle2">Ad Code</Typography>
        <TextField
          fullWidth
          sx={{ mb: 2 }}
          value={formData.AdCode || ""}
          onChange={(e) => handleFieldChange("AdCode", e.target.value)}
        />

        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          Grade this Inquiry
        </Typography>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {gradeOptions.map((option) => {
            const isSelected = formData.grade === option.id;
            return (
              <Box
                key={option.id}
                onClick={() => handleGradeClick(option.id)}
                style={{
                  border: isSelected ? '2px solid #1976d2' : '1px solid #ccc',
                  borderRadius: 4,
                  padding: '8px',
                  cursor: 'pointer',
                  width: 100,
                  textAlign: 'center'
                }}
              >
                <Typography variant="h6" component="div" style={{ fontSize: '1.5rem' }}>
                  {option.emoji}
                </Typography>
                <Typography variant="body2" style={{ fontSize: '0.8rem' }}>
                  {option.text}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </Grid>
    </Grid>
  );

  return (
    <Grid container>
      {/* Left Menu */}
      <Grid item xl={0.5} lg={0.7} md={0.9} sm={3.2} className="leftmenucolor">
        <LeftMenu />
      </Grid>

      {/* Main content */}
      <Grid item xs={12} sm={8.8} md={11.1} lg={11.3} xl={11.5} sx={{ p: 2 }}>
        <Typography variant="h5" gutterBottom>
          Sales Manager Dashboard Stage 2 (Cek Notes)
        </Typography>

        <Paper>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell><b>Inquiry Date</b></TableCell>
                  <TableCell><b>Name</b></TableCell>
                  <TableCell><b>Sales</b></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {inquiries.length > 0 ? (
                  inquiries.map((row) => (
                    <TableRow
                      key={row._id}
                      hover
                      style={{ cursor: 'pointer', ...getRowStyle(row) }}
                      onClick={() => handleRowClick(row)}
                    >
                      <TableCell>{getDate(row)}</TableCell>
                      <TableCell>{getName(row)}</TableCell>
                      <TableCell>{getSales(row)}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      No Inquiries
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>

        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Dialog
            open={openDialog}
            onClose={handleCloseDialog}
            fullWidth
            maxWidth="md"
          >
            <DialogTitle>Edit Inquiry</DialogTitle>
            <DialogContent dividers>
              
              {/* SECTION 1: PREVIOUS DATA */}
              <Box
                sx={{
                  p: 2,
                  backgroundColor: "#fafafa",
                  border: "1px solid #ddd",
                  borderRadius: 2,
                  mb: 3,
                }}
              >
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                  <Typography variant="h6">(1) Previous Data</Typography>
                  {!editMode ? (
                    <Button variant="outlined" onClick={handleEdit}>
                      Edit
                    </Button>
                  ) : (
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <Button variant="outlined" onClick={handleDoneEdit}>
                        Done Edit
                      </Button>
                      <Button variant="outlined" color="error" onClick={handleCancelEdit}>
                        Cancel Edit
                      </Button>
                    </Box>
                  )}
                </Box>

                {!editMode ? renderPreviousDataReadOnly() : renderPreviousDataEdit()}
              </Box>

              {/* SECTION 2: MANAGEMENT NOTES HISTORY (read-only) */}
              <Box
                sx={{
                  p: 2,
                  backgroundColor: "#f0f7ff",
                  border: "1px solid #ccd",
                  borderRadius: 2,
                  mb: 3,
                }}
              >
                <Typography variant="h6" sx={{ mb: 2 }}>
                  (2) Management Notes History
                </Typography>
                {formData.managementFu && formData.managementFu.length > 0 ? (
                  formData.managementFu.map((item, idx) => (
                    <Box key={idx} sx={{ mb: 2 }}>
                      <Typography variant="subtitle2">
                        Date: {item.Date ? new Date(item.Date).toLocaleString() : '(no date)'}
                      </Typography>
                      {item.Note && (
                        <Typography variant="body2">
                          <b>Note:</b> {item.Note}
                        </Typography>
                      )}
                      {item.Response && (
                        <Typography variant="body2">
                          <b>Response:</b> {item.Response}
                        </Typography>
                      )}
                      {item.MGMTNotes && (
                        <Typography variant="body2">
                          <b>MGMTNotes:</b> {item.MGMTNotes}
                        </Typography>
                      )}
                    </Box>
                  ))
                ) : (
                  <Typography>No Management Notes yet.</Typography>
                )}
              </Box>

              {/* SECTION 3: NEXT STEP */}
              <Box
                sx={{
                  p: 2,
                  backgroundColor: "#fff8f0",
                  border: "1px solid #ddd",
                  borderRadius: 2,
                }}
              >
                <Typography variant="h6" sx={{ mb: 2 }}>
                  (3) Next Step
                </Typography>

                <RadioGroup
                  row
                  value={formData.isDropped ? "drop" : formData.isPromo ? "promo" : "follow"}
                  onChange={(e) => {
                    if (e.target.value === "drop") {
                      handleFieldChange("isDropped", true);
                      handleFieldChange("isPromo", false);
                    } else if (e.target.value === "promo") {
                      handleFieldChange("isDropped", false);
                      handleFieldChange("isPromo", true);
                    } else {
                      handleFieldChange("isDropped", false);
                      handleFieldChange("isPromo", false);
                    }
                  }}
                  sx={{ mb: 2 }}
                >
                  <FormControlLabel
                    value="follow"
                    control={<Radio />}
                    label="Update Request"
                  />
                  <FormControlLabel
                    value="drop"
                    control={<Radio />}
                    label="Drop or Done for now"
                  />
                  <FormControlLabel
                    value="promo"
                    control={<Radio />}
                    label="Promotional Blast"
                  />
                </RadioGroup>

                {/* If user selects Update Request (not drop, not promo) */}
                {!formData.isDropped && !formData.isPromo && (
                  <>
                    <Typography variant="subtitle2">Assign to Sales:</Typography>
                    <FormControl fullWidth sx={{ mb: 2 }}>
                      <InputLabel>Sales</InputLabel>
                      <Select
                        value={formData.Sales || ""}
                        label="Sales"
                        onChange={(e) => handleFieldChange("Sales", e.target.value)}
                      >
                        {salesList.map((s) => (
                          <MenuItem key={s} value={s}>
                            {s}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <Typography variant="subtitle2">Update Request:</Typography>
                    <DesktopDateTimePicker
                      value={formData.followUpDate}
                      onChange={(newVal) => handleFieldChange("followUpDate", newVal)}
                      renderInput={(params) => (
                        <TextField
                          fullWidth
                          sx={{ mb: 2 }}
                          {...params}
                        />
                      )}
                    />
                  </>
                )}

                {/* If user selects Promo => let them also pick a date if needed */}
                {formData.isPromo && (
                  <>
                    <Typography variant="subtitle2">Promo Send-Out Date (Optional):</Typography>
                    <DesktopDateTimePicker
                      value={formData.followUpDate}
                      onChange={(newVal) => handleFieldChange("followUpDate", newVal)}
                      renderInput={(params) => (
                        <TextField
                          fullWidth
                          sx={{ mb: 2 }}
                          {...params}
                        />
                      )}
                    />
                  </>
                )}

                <Typography variant="subtitle2">Additional Management Notes (Next Step):</Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  value={formData.managementNotes || ""}
                  onChange={(e) => handleFieldChange("managementNotes", e.target.value)}
                  sx={{ mb: 2, mt: 1 }}
                />
              </Box>
            </DialogContent>

            <DialogActions>
              <Button onClick={handleCloseDialog}>Cancel</Button>
              <Button variant="contained" color="primary" onClick={handleSave}>
                Save
              </Button>
            </DialogActions>
          </Dialog>
        </LocalizationProvider>
      </Grid>
    </Grid>
  );
}